
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/lexicon/[lexiconLetterUrl]",
      function () {
        return require("private-next-pages/news/lexicon/[lexiconLetterUrl]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/lexicon/[lexiconLetterUrl]"])
      });
    }
  